import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionsModule } from './subscriptions/subscriptions.module';
import { BlocHtmlModule } from './bloc-html/bloc-html.module';
import { TransactionalEmailModule } from './transactional-email/transactional-email.module';
import { ComponentsModule } from './components/components.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SubscriptionsModule,
    BlocHtmlModule,
    TransactionalEmailModule,
    ComponentsModule
  ],
  exports: [SubscriptionsModule]
})
export class MarketingModule { }

